/**
 * Login Page Style Registry - Themes > Login Page
 * 第一個 style: Redesigned Sign In (Stitch Project 3749155811323131250, Screen 4bf881482ecb4d0d842d83084786965b)
 */

import type { ComponentType } from 'react'
import LoginPageRedesignedSignIn from './LoginPageRedesignedSignIn'

export type LoginStyleComponentProps = {
  onLogin?: () => void
  logoImageUrl?: string
}

export type LoginStyleEntry = {
  styleId: string
  label: string
  /** Stitch project ID */
  stitchProjectId?: string
  /** Stitch screen ID */
  stitchScreenId?: string
  /** React component for preview (accepts onLogin?: () => void for AppFactory preview) */
  Component: ComponentType<LoginStyleComponentProps>
}

const LOGIN_STYLE_OPTIONS: LoginStyleEntry[] = [
  {
    styleId: 'redesigned-sign-in',
    label: 'Redesigned Sign In',
    stitchProjectId: '3749155811323131250',
    stitchScreenId: '4bf881482ecb4d0d842d83084786965b',
    Component: LoginPageRedesignedSignIn,
  },
]

export function getLoginStyleById(styleId: string): LoginStyleEntry | undefined {
  return LOGIN_STYLE_OPTIONS.find((s) => s.styleId === styleId)
}

export function listLoginStyles(): LoginStyleEntry[] {
  return [...LOGIN_STYLE_OPTIONS]
}

export function getLoginStyleComponent(
  styleId: string
): ComponentType<LoginStyleComponentProps> | null {
  const entry = getLoginStyleById(styleId)
  return entry?.Component ?? null
}
